// Tenky klient na Mercure hub (2026-08-17, viz
// docs/superpowers/specs/2026-08-17-mercure-notifications-design.md) -
// jedno globalni EventSource spojeni na privatni topic prihlaseneho
// trenera, jednoduchy pub/sub pro komponenty, co chteji reagovat na
// konkretni "type" v payloadu (zatim jen 'player_message', pripraveno na
// dalsi typy udalosti v budoucnu beze zmeny tohohle souboru).
import {API_ENTRYPOINT} from '@/config/entrypoint';

let eventSource = null;
const listenersByType = {};

function getHubUrl(topic) {
    const url = new URL('/.well-known/mercure', API_ENTRYPOINT);
    url.searchParams.set('topic', topic);
    return url;
}

function connect(topic) {
    disconnect();
    eventSource = new EventSource(getHubUrl(topic), {withCredentials: true});
    eventSource.onmessage = (event) => {
        let payload;
        try {
            payload = JSON.parse(event.data);
        } catch (e) {
            return;
        }
        const callbacks = listenersByType[payload.type];
        if (callbacks) {
            callbacks.forEach((cb) => cb(payload));
        }
    };
    // EventSource se po chybe/vypadku sam nativne reconnectuje
    // (standardni browser chovani) - zadny vlastni retry netreba.
}

function disconnect() {
    if (eventSource) {
        eventSource.close();
        eventSource = null;
    }
}

function onMessage(type, callback) {
    if (!listenersByType[type]) {
        listenersByType[type] = new Set();
    }
    listenersByType[type].add(callback);
    return () => {
        listenersByType[type].delete(callback);
    };
}

export default {connect, disconnect, onMessage};
